import { Register } from '@eastcoal/auth/components/Register'
import { RouteItem } from '@eastcoal/router/types/route'

export const registerRotue: RouteItem = {
  title: '注册',
  path: '/register',
  hideInMenu: true,
  element: <Register />
}
